<template>
  <van-action-sheet v-model="value" title="请选择支付方式" class="channel-chooser">
    <div
      class="channel-item border"
      v-for="item in channel_options"
      :key="item"
      @click="toBuy(item)"
    >
      <img :src="channel_icon(item)" class="channel_icon">
      <span>{{channel_name(item)}}</span>
    </div>
  </van-action-sheet>
</template>
<script>
  import Vue from 'vue'
  import {ActionSheet} from 'vant';
  import channels from '../../constant/channels'
  import buyVIP from '../../api/order'
  import {click_event} from '../../tools/mgtv/analysis'

  Vue.use(ActionSheet);

  export default {
    name: 'ChannelChooser',
    data: function () {
      return {
        product_id: null,
        value: false,
        channels: channels,
        product_type: null,
        channel_options: [],
      }
    },
    props: [],
    methods: {
      show(params) {
        this.value = true;
        this.product_id = params.product_id;
        this.product_type = params.product_type;
        this.type = params.type;
        this.channel_options = params.channel_options;
        click_event('拉起渠道选择器');
      },
      toBuy(channel) {
        this.value = false;
       buyVIP(this.product_id, this.product_type, channel);
      },
      channel_icon(channel) {
        const icons = {
          wechat: '//vipcdn.mgtv.com/lego/20191118/channel_icons/channel_wechat.png',
          alipay: '//vipcdn.mgtv.com/lego/20191118/channel_icons/channel_alipay.png',
          cmbpay: '//vipcdn.mgtv.com/lego/20191118/channel_icons/channel_cmbpay.png',　//招行
          ccbpay: '//vipcdn.mgtv.com/lego/20191118/channel_icons/channel_ccbpay.png', //建行
          jdpay: '//vipcdn.mgtv.com/lego/20191118/channel_icons/channel_jdpay.png',　//京东
          mgtvqianbao: '//vipcdn.mgtv.com/upload3/201902/18/mgpay_icon2.png' //芒果钱包支付
        };
        let icon = icons[channel];
        return icon ? icon : '';
      },
      channel_name(channel) {
        const names = {
          wechat: '微信',
          alipay: '支付宝',
          cmbpay: '招行一卡通',　//招行
          ccbpay: '建行龙支付', //建行
          jdpay: '京东支付',　//京东
          mgtvqianbao: '芒果钱包' //芒果钱包支付
        }
        let name = names[channel];
        return name ? name : '';
      }
    },
    computed: {},
  };
</script>


<style lang="stylus">

  .channel-chooser
    .border
      border-bottom 1px solid #eaeaea
    .channel-item
      height 60px
      position relative
      display flex
      align-items center
      > img
        width .58rem
        height @width
        margin-left 2.8rem
      > span
        font-size 16px
        height @height
        line-height: @height
        margin-left .1rem

    　

</style>
